"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ol = require("openlayers");
const _ = require("lodash");
const utmArea_1 = require("./utmArea");
var Orientation;
(function (Orientation) {
    Orientation[Orientation["NONE"] = 0] = "NONE";
    Orientation[Orientation["PORTRAIT"] = 1] = "PORTRAIT";
    Orientation[Orientation["LANDSCAPE"] = 2] = "LANDSCAPE";
})(Orientation = exports.Orientation || (exports.Orientation = {}));
function assertConsistency(v) {
    throw new Error(`Internal inconsistency. Unacounted value: ${JSON.stringify(v)}`);
}
function keepAspectRatio(start, end, ratio, orientation) {
    const width = Math.abs(start[0] - end[0]);
    const height = Math.abs(start[1] - end[1]);
    switch (orientation) {
        case Orientation.PORTRAIT:
            return [end[0], start[1] - width / ratio];
        case Orientation.LANDSCAPE:
            return [start[0] + height / ratio, end[1]];
        case Orientation.NONE:
            return end;
    }
    assertConsistency(orientation);
}
function toMapSelection(polygon) {
    const coords = polygon.getCoordinates()[0];
    return {
        topLeft: coords[0],
        bottomRight: coords[2]
    };
}
exports.toMapSelection = toMapSelection;
function createAreaSelector(selectionLayer, getAspectRatioOrientation, onSelection, onDrawEnd) {
    const component = this;
    const drawSelection = new ol.interaction.Draw({
        source: selectionLayer,
        type: 'Circle',
        geometryFunction(coordinates, polygon) {
            const area = {
                topLeft: coordinates[0],
                bottomRight: _.defaultTo(coordinates[1], coordinates[0])
            };
            const box = utmArea_1.getUTMAreaBox({ area, getAspectRatioOrientation, polygon });
            onSelection(toMapSelection(box));
            return box;
        }
    });
    drawSelection.on('drawstart', (event) => {
        selectionLayer.clear();
    });
    drawSelection.on('drawend', (event) => {
        onDrawEnd();
    });
    return drawSelection;
}
exports.createAreaSelector = createAreaSelector;



//////////////////
// WEBPACK FOOTER
// ./src/map/areaSelector.ts
// module id = 285
// module chunks = 0